package se.mittpass.web.pages

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun PrivacyPage(onBack: () -> Unit) {
    LegalPageShell(
        title = "Integritetspolicy",
        subtitle = "Senast uppdaterad: 2026-05-29",
        onBack = onBack
    ) {
        LegalSection("1. Personuppgiftsansvarig") {
            Text("Mittpass är en produkt som tillhandahålls av Brave Consulting AB (org.nr 559291-0318) (\"vi\", \"oss\", \"tjänsten\"). Brave Consulting AB ansvarar för behandlingen av de personuppgifter som registreras i tjänsten. Kontakt: kontakt@mittpass.se.")
        }
        LegalSection("2. Vilka uppgifter vi samlar in") {
            Text("Vi behandlar följande personuppgifter om anställda och chefer: namn, e-postadress, personnummer, telefonnummer, arbetstider (in- och utcheckning), frånvaro, schema och lönegrundande uppgifter. Uppgifterna anges av arbetsgivaren (kunden) och används uteslutande för att tillhandahålla tjänsten.")
        }
        LegalSection("3. Rättslig grund") {
            Text("Behandlingen grundar sig på avtal (tjänsteavtalet med arbetsgivaren) och berättigat intresse (personaladministration). Personnummer behandlas med stöd av 10 § lagen (2018:218) med kompletterande bestämmelser till EU:s dataskyddsförordning.")
        }
        LegalSection("4. Underbiträden (subprocessorer)") {
            Text("Vi anlitar följande underleverantörer för att leverera tjänsten: PostgreSQL-databas (Hetzner, EU), Firebase Cloud Messaging/FCM (Google, EU-databehandlingsavtal), e-postleverantör (konfigureras av kunden). Full lista och DPA tillhandahålls på begäran.")
        }
        LegalSection("5. Lagring och radering") {
            Text("Personuppgifter lagras så länge avtalet löper och raderas inom 30 dagar efter avtalets upphörande, om inte längre lagringstid krävs enligt lag (t.ex. bokföringslagen 7 år).")
        }
        LegalSection("6. Dina rättigheter") {
            Text("Registrerade personer har rätt att begära tillgång till, rättelse av eller radering av sina personuppgifter, samt att invända mot behandlingen. Begäran skickas till kontakt@mittpass.se. Du har rätt att inge klagomål till Integritetsskyddsmyndigheten (imy.se).")
        }
        LegalSection("7. Kontakt") {
            Text("Frågor om vår integritetspolicy besvaras av kontakt@mittpass.se.")
        }

    }
}

@Composable
fun TermsPage(onBack: () -> Unit) {
    LegalPageShell(
        title = "Användarvillkor",
        subtitle = "Senast uppdaterad: 2026-05-29",
        onBack = onBack
    ) {
        LegalSection("1. Avtalsparter") {
            Text("Dessa villkor gäller mellan Brave Consulting AB (org.nr 559291-0318), tillhandahållare av Mittpass, och den organisation (\"kunden\") som ingår avtal om att använda tjänsten Mittpass.")
        }
        LegalSection("2. Tjänstens innehåll") {
            Text("Mittpass är en webbaserad personalhanteringstjänst som erbjuder schemaläggning, tidrapportering, personalliggare och relaterade funktioner. Tjänsten levereras som-är och kan förändras utan förvarning.")
        }
        LegalSection("3. Pris och betalning") {
            Text("Priset framgår av det prisavtal som ingås vid köptillfället. Faktura skickas månadsvis i efterskott. Förfallodatum är 30 dagar. Vid utebliven betalning förbehåller Mittpass rätten att spärra åtkomst till tjänsten.")
        }
        LegalSection("4. Kundens ansvar") {
            Text("Kunden ansvarar för att de uppgifter som registreras är korrekta och för att informera berörd personal om behandlingen. Kunden är personuppgiftsansvarig för de anställdas uppgifter; Mittpass är personuppgiftsbiträde.")
        }
        LegalSection("5. Tillgänglighet och SLA") {
            Text("Vi strävar efter 99 % drifttid. Planerat underhåll sker utanför kontorstid och meddelas i förväg. Mittpass ansvarar inte för driftstopp orsakade av tredje part (internetoperatör, molninfrastruktur etc.).")
        }
        LegalSection("6. Immateriella rättigheter") {
            Text("All kod, design och innehåll i tjänsten ägs av Mittpass. Kunden erhåller en icke-exklusiv, icke-överlåtbar nyttjanderätt under avtalstiden.")
        }
        LegalSection("7. Ansvarsbegränsning") {
            Text("Mittpass ansvar är begränsat till direkta skador och kan aldrig överstiga de avgifter kunden betalat under de senaste tre månaderna.")
        }
        LegalSection("8. Uppsägning") {
            Text("Avtalet löper tillsvidare med en månads ömsesidig uppsägningstid. Vid väsentlig avtalsbrott kan endera part säga upp avtalet med omedelbar verkan.")
        }
        LegalSection("9. Tillämplig lag") {
            Text("Svensk lag tillämpas. Tvister avgörs i svensk allmän domstol.")
        }

    }
}

@Composable
private fun LegalPageShell(
    title: String,
    subtitle: String,
    onBack: () -> Unit,
    content: @Composable () -> Unit
) {
    Div({
        style {
            property("min-height", "100vh")
            property("font-family", "'Inter', 'Segoe UI', system-ui, sans-serif")
            property("background", "var(--rp-overlay)")
        }
    }) {
        Div({
            style {
                property("background", "linear-gradient(135deg, var(--rp-pine), var(--rp-iris))")
                property("padding", "1.5rem 2rem")
                property("display", "flex")
                property("align-items", "center")
                property("gap", "1rem")
            }
        }) {
            Button({
                onClick { onBack() }
                style {
                    property("background", "rgba(255,255,255,0.2)")
                    property("border", "none")
                    property("color", "white")
                    property("font-size", "1rem")
                    property("cursor", "pointer")
                    property("padding", "0.5rem 1rem")
                    property("border-radius", "50px")
                    property("font-weight", "700")
                }
            }) { Text("\u2190 Tillbaka") }
            Span({
                style {
                    property("font-size", "1.3rem")
                    property("font-weight", "900")
                    property("color", "white")
                }
            }) { Text("Mittpass") }
        }

        Div({
            style {
                property("max-width", "800px")
                property("margin", "0 auto")
                property("padding", "3rem 1.5rem")
            }
        }) {
            H1({
                style {
                    property("font-size", "2rem")
                    property("font-weight", "900")
                    property("color", "var(--rp-text)")
                    property("margin", "0 0 0.5rem 0")
                }
            }) { Text(title) }
            P({
                style {
                    property("color", "var(--rp-muted)")
                    property("font-size", "0.9rem")
                    property("margin", "0 0 2.5rem 0")
                }
            }) { Text(subtitle) }

            Div({
                style {
                    property("background", "var(--rp-surface)")
                    property("border-radius", "20px")
                    property("padding", "2rem")
                    property("box-shadow", "0 2px 16px rgba(0,0,0,0.06)")
                }
            }) {
                content()
            }
        }
    }
}

@Composable
private fun LegalSection(heading: String, body: @Composable () -> Unit) {
    H3({
        style {
            property("font-size", "1rem")
            property("font-weight", "800")
            property("color", "var(--rp-text)")
            property("margin", "1.5rem 0 0.5rem 0")
        }
    }) { Text(heading) }
    P({
        style {
            property("font-size", "0.95rem")
            property("color", "var(--rp-text)")
            property("line-height", "1.7")
            property("margin", "0")
        }
    }) { body() }
}

@Composable
fun DpaPage(onBack: () -> Unit) {
    LegalPageShell(
        title = "Personuppgiftsbiträdesavtal (DPA)",
        subtitle = "Senast uppdaterad: 2026-05-29",
        onBack = onBack
    ) {
        LegalSection("1. Parter och roller") {
            Text("Detta personuppgiftsbiträdesavtal (\"DPA\") gäller mellan den organisation som använder Mittpass (\"personuppgiftsansvarig\") och Brave Consulting AB (org.nr 559291-0318), leverantör av Mittpass (\"personuppgiftsbiträde\"). Avtalet reglerar Brave Consulting AB:s behandling av personuppgifter på den personuppgiftsansvariges vägnar i enlighet med artikel 28 i EU:s dataskyddsförordning (GDPR).")
        }
        LegalSection("2. Ändamål och instruktioner") {
            Text("Mittpass behandlar personuppgifter uteslutande för att tillhandahålla tjänsten Mittpass (personalliggare, schemaläggning, tidrapportering och relaterade funktioner) och enbart enligt den personuppgiftsansvariges dokumenterade instruktioner. Mittpass behandlar inte uppgifterna för egna ändamål.")
        }
        LegalSection("3. Kategorier av registrerade och uppgifter") {
            Text("Registrerade: anställda och chefer hos den personuppgiftsansvarige. Kategorier av personuppgifter: namn, e-postadress, personnummer, telefonnummer, arbetstider (in- och utcheckning), frånvaro, schema och lönegrundande uppgifter. Inga särskilda kategorier av personuppgifter (artikel 9) behandlas av Mittpass.")
        }
        LegalSection("4. Säkerhetsåtgärder") {
            Text("Mittpass vidtar lämpliga tekniska och organisatoriska säkerhetsåtgärder, inklusive: krypterad dataöverföring (TLS), krypterade lösenord (bcrypt), JWT-baserad autentisering med kortlivade tokens, begränsad åtkomst till produktionsdatabas, lagring inom EU (Hetzner, Frankfurt).")
        }
        LegalSection("5. Underbiträden") {
            Text("Mittpass anlitar följande underbiträden: Hetzner Online GmbH (databaslagring, EU) och Google LLC (Firebase Cloud Messaging för push-notiser, med EU-standardavtalsklausuler). Den personuppgiftsansvarige ger ett generellt förhandstillstånd till användning av underbiträden. Mittpass informerar om planerade ändringar och ger möjlighet att invända.")
        }
        LegalSection("6. Internationella överföringar") {
            Text("Personuppgifter lagras primärt inom EU/EES. Firebase Cloud Messaging innebär överföring till USA med stöd av EU:s standardavtalsklausuler (SCC) och Googles Data Processing Addendum.")
        }
        LegalSection("7. Konfidentialitet") {
            Text("Mittpass säkerställer att all personal med åtkomst till personuppgifterna är bunden av konfidentialitetsskyldighet och enbart behandlar uppgifterna i enlighet med detta avtal.")
        }
        LegalSection("8. Biträde vid utövande av rättigheter") {
            Text("Mittpass bistår den personuppgiftsansvarige vid hantering av registrerades rättigheter (tillgång, rättelse, radering, begränsning, dataportabilitet) samt vid konsekvensbedömningar (DPIA) när det är tillämpligt. Begäran riktas till kontakt@mittpass.se.")
        }
        LegalSection("9. Personuppgiftsincidenter") {
            Text("Mittpass underrättar den personuppgiftsansvarige utan onödigt dröjsmål, och senast inom 72 timmar, efter att ha fått kännedom om en personuppgiftsincident som rör de behandlade uppgifterna.")
        }
        LegalSection("10. Radering och återlämnande") {
            Text("Vid avtalets upphörande raderar Mittpass alla personuppgifter inom 30 dagar, om inte längre lagringstid krävs enligt lag. Den personuppgiftsansvarige kan dessförinnan begära export av data i CSV-format.")
        }
        LegalSection("11. Revision och granskning") {
            Text("Den personuppgiftsansvarige har rätt att granska Mittpass efterlevnad av detta DPA, antingen via granskning av dokumentation eller, med rimlig varsel, inspektion. Mittpass tillhandahåller all information som är nödvändig för att påvisa efterlevnad.")
        }
        LegalSection("12. Avtalstid") {
            Text("DPA:n gäller under hela avtalstiden för Mittpass och upphör automatiskt när avtalet om tjänsten upphör att gälla.")
        }
        LegalSection("13. Tillämplig lag och kontakt") {
            Text("Svensk lag tillämpas. Frågor om detta DPA besvaras av kontakt@mittpass.se. Tillsynsmyndighet: Integritetsskyddsmyndigheten (IMY), imy.se.")
        }
    }
}

// ─────────────────────────────────────────
// ACCOUNT DELETION (Apple App Store Guideline 5.1.1(v) & Google Play Data Safety)
// ─────────────────────────────────────────
@Composable
fun DeleteAccountPage(onBack: () -> Unit) {
    LegalPageShell(
        title = "Radera konto och data (Account Deletion)",
        subtitle = "Information enligt Apples och Googles riktlinjer för borttagning av användarkonto",
        onBack = onBack
    ) {
        LegalSection("1. Hur du raderar ditt konto") {
            Text("Du kan när som helst begära att ditt konto och alla tillhörande personuppgifter raderas från Mittpass.")
            Ul({ style { property("margin-top", "0.5rem"); property("line-height", "1.6") } }) {
                Li { Text("I appen / webben: Gå till Inställningar \u2192 Profil/Konto \u2192 Klicka på \"Radera mitt konto\".") }
                Li { Text("Via e-post: Skicka ett meddelande från din registrerade e-postadress till kontakt@mittpass.se med ämnet \"Begäran om kontoborttagning\".") }
            }
        }
        LegalSection("2. Vilken data som raderas") {
            Text("Vid radering av ett personligt användarkonto tas följande uppgifter bort permanent och oåterkalleligt inom 30 dagar:")
            Ul({ style { property("margin-top", "0.5rem"); property("line-height", "1.6") } }) {
                Li { Text("Inloggningsuppgifter, namn, e-postadress, telefonnummer och profilinformation.") }
                Li { Text("Push-token och enhetsidentifierare för notiser.") }
                Li { Text("Personliga inställningar och preferenser.") }
            }
        }
        LegalSection("3. Data som sparas enligt lagkrav") {
            Text("Observera att viss verksamhetsdata sparas i enlighet med tvingande svensk och europeisk lagstiftning (GDPR Art 17(3)(b)):")
            Ul({ style { property("margin-top", "0.5rem"); property("line-height", "1.6") } }) {
                Li { Text("Personalliggare & tidsstämplar: Enligt Skatteförfarandelagen (2011:1244) måste personalliggaren sparas oförändrad i 2 år efter det kalenderår som kontrollen avser.") }
                Li { Text("Egenkontroll & Livsmedelskontroll (HACCP): Enligt Livsmedelslagen och EU:s livsmedelsförordning (EG 852/2004) sparas temperaturloggar, signaturer och avvikelser som revisionsbevis för miljöförvaltningens tillsyn.") }
                Li { Text("Bokföring och löneunderlag: Enligt Bokföringslagen (1999:1078) sparas faktura- och lönedata i 7 år.") }
            }
            Text("När den lagstadgade lagringstiden har löpt ut raderas eller anonymiseras denna verksamhetsdata automatiskt.")
        }
        LegalSection("4. Kontakt för dataskyddsfrågor") {
            Text("Har du frågor kring radering av data eller vill följa upp en begäran, kontakta Brave Consulting AB på kontakt@mittpass.se.")
        }
    }
}

// ─────────────────────────────────────────
// SUPPORT & APP INFORMATION (App Store / Google Play Support URL)
// ─────────────────────────────────────────
@Composable
fun SupportPage(onBack: () -> Unit) {
    LegalPageShell(
        title = "Support & Hjälp (App Support)",
        subtitle = "Hjälpcenter för Mittpass användare på iOS, Android och webb",
        onBack = onBack
    ) {
        LegalSection("1. Kundsupport & Teknisk hjälp") {
            Text("Behöver du hjälp med att komma igång, har tekniska frågor eller vill rapportera en bugg?")
            P({ style { property("margin-top", "0.5rem") } }) {
                Text("E-post: ")
                A(href = "mailto:kontakt@mittpass.se", attrs = { style { property("color", "var(--rp-pine)"); property("font-weight", "600") } }) {
                    Text("kontakt@mittpass.se")
                }
            }
            Text("Vi svarar normalt inom en arbetsdag måndag–fredag.")
        }
        LegalSection("2. Vanliga frågor (FAQ)") {
            Ul({ style { property("line-height", "1.6") } }) {
                Li { Text("Hur loggar jag in? Använd samma inloggningsuppgifter på webben och i mobilapparna (iOS/Android).") }
                Li { Text("Hur bjuder jag in personal? Som chef/administratör går du till 'Personal' i dashboarden och klickar 'Bjud in medarbetare'.") }
                Li { Text("Fungerar personalliggaren offline? In- och utstämpling kräver internetuppkoppling för att tidsstämplas direkt mot servern enligt Skatteverkets krav.") }
            }
        }
        LegalSection("3. Företagsinformation") {
            Text("Mittpass utvecklas och driftas av:")
            P({ style { property("margin-top", "0.5rem"); property("line-height", "1.5") } }) {
                Text("Brave Consulting AB")
                Br()
                Text("Org.nr: 559291-0318")
                Br()
                Text("E-post: kontakt@mittpass.se")
            }
        }
    }
}
